import { Component } from '@angular/core';
import { SegovPage } from 'src/app/app.routes';
import { LinkClickable, SegovSigepoHeaderSectionComponent } from 'src/app/controls/segov-sigepo-header-section/segov-sigepo-header-section.component';
import { SegovSigepoPortalBodyComponent } from 'src/app/controls/segov-sigepo-portal-body/segov-sigepo-portal-body.component';

@Component({
  selector: 'app-acessibilidade-page',
  standalone: true,
  imports: [
    SegovSigepoPortalBodyComponent,
    SegovSigepoHeaderSectionComponent,
  ],
  templateUrl: './acessibilidade-page.component.html'
})
export class AcessibilidadePageComponent {
  public title = "Torne a navegação mais inclusiva e acessível"
  public RouteStack: LinkClickable[] = [
    { title: "Início", route: SegovPage.Inicio },
    { title: "Acessibilidade", route: SegovPage.Acessibilidade }
  ];
}
